import dayjs from "dayjs";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Tag,
  Flex,
  Table,
  Button,
  TableRow,
  useModal,
  NoResults,
  TableBody,
  TableCell,
  TableHead,
  InnerPanel,
  StretchPanel,
  TableHeadCell,
} from "@ubisend/pulse-components";

import { revokeInvite } from "../../api";

const ExistingInvites = () => {
  const query = useQuery({ queryKey: ["users/invites"] });
  const { showModal, hideModal } = useModal();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: revokeInvite,
    onSuccess: () => queryClient.refetchQueries("users/invites"),
  });

  const handleRemove = (invite) => {
    showModal({
      header: "Revoke Invitation",
      body: `Are you sure you want to revoke the invitation for ${invite.email}?`,
      handleConfirm: async () => {
        try {
          mutation.mutate({ id: invite.id });
        } finally {
          hideModal();
        }
      },
    });
  };

  return (
    <InnerPanel header="Invitations" mt>
      <StretchPanel>
        <Table loading={query.isLoading} loadingColumns={4}>
          {!query.isLoading && query.data?.data?.length > 0 && (
            <>
              <TableHead>
                <TableRow>
                  <TableHeadCell>Email</TableHeadCell>
                  <TableHeadCell>Role</TableHeadCell>
                  <TableHeadCell>Date</TableHeadCell>
                  <TableHeadCell>Actions</TableHeadCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {query.data.data.map((invite, key) => (
                  <TableRow key={key}>
                    <TableCell>{invite.email}</TableCell>
                    <TableCell>
                      <Tag>{invite.role}</Tag>
                    </TableCell>
                    <TableCell>{`${dayjs(invite.sent_at).format("YYYY-MM-DD HH:mm:ss")}`}</TableCell>
                    <TableCell>
                      <Button icon="minus" onClick={() => handleRemove(invite)}>
                        Revoke
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </>
          )}
        </Table>

        {!query.isLoading && query.data?.data?.length === 0 && (
          <Flex middle>
            <NoResults
              text="You haven't invited anyone yet"
              subtitle="Go get some mates and come back later"
            />
          </Flex>
        )}
      </StretchPanel>
    </InnerPanel>
  );
};

export default ExistingInvites;
